import React from "react"
import { Viewer, Worker } from "@react-pdf-viewer/core"
import "@react-pdf-viewer/core/lib/styles/index.css"

const PDFViewer: React.FC<{ dataUrl: string }> = ({ dataUrl }) => {
    return (
        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
            <Viewer fileUrl={dataUrl} />
        </Worker>
    )
}

export default PDFViewer
